var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-count-config"},[_vm._v(" "+_vm._s(_vm.$t(`filter.pageSize`))+" "),_c('a-input-number',{model:{value:(_vm.pageSizeLocal),callback:function ($$v) {_vm.pageSizeLocal=$$v},expression:"pageSizeLocal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }